import type { VirtualNodeProps } from '@gitbook/slate-react';
import { VirtualizedCodeBlockLine } from '@gitbook/spine-react';

export function VirtualBlockCodeLine(props: VirtualNodeProps) {
    return (
        <VirtualizedCodeBlockLine ref={props.domRef} {...props}>
            {props.children}
        </VirtualizedCodeBlockLine>
    );
}
